module.exports = __webpack_public_path__ + "img/project-1.49f9c272.png";